import Store from 'store/store';

Store.on('ENABLE_TRAILER_OVERLAY', (video) => {
	Store.emit('TOGGLE_TRAILER_OVERLAY', !!video, video);
});

Store.on('TOGGLE_TRAILER_OVERLAY', (open, video) => {
	if (open) {
		Store.emit('PAUSE_ALL_VIDEOS');
	}
	if (!Store.get().trailerOverlay) {
		Store.get().set({ trailerOverlay: {} });
	}

	if (typeof open !== 'boolean') {
		open = !Store.get().trailerOverlay.overlayOpen;
	}

	const data = video ? { video } : Store.get().appData?.options?.videoOverlay;
	Store.get().trailerOverlay.set({ overlayOpen: open, data });
	if (open) {
		Store.get().trailerOverlay.set({ overlayTriggered: true });
	}

	Store.emit(open ? 'ENABLE_SCROLLING_LOCK' : 'DISABLE_SCROLLING_LOCK');

	if (open) {
		Store.emit('SET_HEADER_ACTION', {
			icon: 'close',
			action: () => Store.emit('TOGGLE_TRAILER_OVERLAY', false),
			tag: 'closeTrailerOverlay'
		});
	} else {
		Store.emit('REMOVE_HEADER_ACTIONS', 'closeTrailerOverlay');
	}
});